module.exports = __webpack_public_path__ + "img/musee-grevin.5c6c342a.png";